import styled from '@emotion/styled'
import { theme } from '@mindfulchefuk/design-system/system'

export const ErrorMessage = styled.div`
  color: ${theme.colors.tomato};
  display: block;
  ${theme.typography['body-sm']};
  margin: ${theme.space[8]} 0 0;
`
